// @ts-nocheck
export const localeCodes =  [
  "en",
  "fr",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_ca30d574",
      load: () => import("#nuxt-i18n/ca30d574" /* webpackChunkName: "locale_en_46json_ca30d574" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_5ab469f1",
      load: () => import("#nuxt-i18n/5ab469f1" /* webpackChunkName: "locale_fr_46json_5ab469f1" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_206f4950",
      load: () => import("#nuxt-i18n/206f4950" /* webpackChunkName: "locale_es_46json_206f4950" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US"
  },
  {
    code: "fr",
    language: "fr-FR"
  },
  {
    code: "es",
    language: "es-ES"
  }
]
/** client **/

/** client-end **/